/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  Text,
  TouchableOpacity,
  Image,
} from 'react-native';
import { Button } from 'react-native-elements';

import AORTypes from '../../types';
import ScrollFading from '../../components/effects/ScrollFading';
import AppBadgeById from '../../components/apps/AppBadgeById';
import { translate } from '../../locales/i18n';
import tagsEn from '../../data/locale/tags/en.json';
import tagsRu from '../../data/locale/tags/ru.json';
import styles from '../../styles';
import { language } from '../../localization';
import imageLogo from '../../assets/images/aionrails.png';
import ImageLogoUnderlay from '../../assets/images/logo-underlay.svg';
import infraConfig from '../../config.json';

const TAGS = {
  en: tagsEn,
  ru: tagsRu,
};

const APPS = infraConfig.envName === 'prod' ? {
  en: [
    '2690e2b4-b000-4b99-899c-62fbc2fcd228', // AI-on-Rails Consulting
    '19d67c03-c18f-44bb-81bc-3a89204a609d', // PartCAD
  ],
  ru: [
  ],
} : {
  en: [
  ],
  ru: [
  ],
};

class Main extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Main';
  }

  render() {
    const { history, user } = this.props;
    console.log('Main');
    console.log(user);

    const lang = language();

    return (
      <View
        // style={[user ? styles.view.headless : styles.view.headed, {
        style={[styles.view.headed, {
          width: '100%',
          alignItems: 'center',
        }]}
      >
        <View
          style={{
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            paddingLeft: 50,
            minHeight: 64,
          }}
        >
          <View
            style={{
              flex: 1,
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              alignContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <TouchableOpacity
              accessibilityLabel="AI on Rails"
              accessibilityRole="link"
              href="/"
              style={{
                padding: 0,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              }}
              onPress={() => {
                history.push('/');
              }}
            >
              <Text
                style={{
                  fontFamily: styles.primaryFont700,
                  fontWeight: '700',
                  fontSize: 24,
                  color: '#333333',
                  width: '100%',
                  flexWrap: 'nowrap',
                }}
              >
                AI on Rails
              </Text>
              <Image style={{ width: 40, height: 40, marginLeft: 10, marginRight: 20 }} source={imageLogo} />
            </TouchableOpacity>
            {!user && (
              // <>
              //   <Button
              //     clear
              //     title={translate('menu_signup')}
              //     containerStyle={[styles.button.secondaryContainer, {}]}
              //     buttonStyle={[styles.button.secondary, {
              //       backgroundColor: 'white',
              //     }]}
              //     titleStyle={styles.button.secondaryTitle}
              //     // onPress={() => history.go(-1)}
              //     onPress={() => history.push('/signup')}
              //   />
              <Button
                clear
                title={translate('menu_signin')}
                containerStyle={[styles.button.secondaryContainer, {}]}
                buttonStyle={styles.button.secondary}
                titleStyle={styles.button.secondaryTitle}
                // onPress={() => history.go(-1)}
                onPress={() => {
                  console.log('signin');
                  console.log(history);

                  history.push('/signin');
                }}
              />
              // </>
            )}
          </View>
        </View>
        <ScrollFading
          containerStyle={{
            width: '100%',
            flex: 1,
            alignItems: 'center',
          }}
          style={{
            flex: 1,
            width: '100%',
            maxWidth: 600,
            flexDirection: 'column',
          }}
          color="#fff"
          showsVerticalScrollIndicator={false}
        >
          {/* <View
            style={{
              width: '100%',
              margin: 10,
            }}
          >
            <TouchableOpacity
              accessibilityLabel="AI on Rails"
              accessibilityRole="link"
              href="/"
              style={{
                padding: 0,
                flexDirection: 'row',
                alignItems: 'center',
              }}
              onPress={() => {
                history.push('/');
              }}
            >
              <Image style={{ width: 40, height: 40, marginRight: 10 }} source={imageLogo} />
              <Text
                style={{
                  fontFamily: styles.primaryFont700,
                  fontWeight: '700',
                  fontSize: 24,
                  color: '#333333',
                  width: '100%',
                  flexWrap: 'nowrap',
                }}
              >
                AI on Rails
              </Text>
            </TouchableOpacity>
          </View> */}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                width: '100%',
                fontFamily: styles.primaryFont700,
                fontWeight: '700',
                fontSize: 14,
                lineHeight: 20,
                color: styles.primaryColor,
                margin: 10,
                textTransform: 'uppercase',
              }}
            >
              {translate('main_tagline')}
            </Text>
          </View>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              margin: 5,
              marginTop: 20,
            }}
          >
            <Text
              style={{
                fontFamily: styles.primaryFont700,
                fontWeight: '700',
                fontSize: 36,
                lineHeight: 45,
                color: '#333333',
                margin: 5,
                marginRight: 0,
                flexGrow: 1,
              }}
            >
              {translate('main_title1')}
            </Text>
            <Text
              style={{
                fontFamily: styles.primaryFont700,
                fontWeight: '700',
                fontSize: 36,
                lineHeight: 45,
                color: styles.primaryColor,
                margin: 5,
                flexGrow: 10,
              }}
            >
              {translate('main_title2')}
            </Text>
            {translate('main_title3') !== '' && (
              <Text
                style={{
                  fontFamily: styles.primaryFont700,
                  fontWeight: '700',
                  fontSize: 36,
                  lineHeight: 45,
                  color: '#333333',
                  margin: 5,
                  flexGrow: 100,
                }}
              >
                {translate('main_title3')}
              </Text>
            )}
          </View>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                fontFamily: styles.primaryFont400,
                fontWeight: '400',
                fontSize: 16,
                lineHeight: 22,
                color: '#333333',
                margin: 10,
                marginVertical: 20,
              }}
            >
              {translate('main_description')}
            </Text>
          </View>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <Button
              title={translate('menu_find_apps')}
              containerStyle={{
                alignSelf: 'center',
              }}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => {
                history.push('/ai-agents');
              }}
            />
            <Button
              clear
              title={translate('publisher_apps_token')}
              containerStyle={[styles.button.secondaryContainer, {}]}
              buttonStyle={styles.button.secondary}
              titleStyle={styles.button.secondaryTitle}
              // onPress={() => history.go(-1)}
              onPress={() => history.push('/token')}
            // onPress={() => history.push('/addapp')}
            />
          </View>

          {/* The list of apps. */}
          {APPS[lang] && APPS[lang].length > 0 && (
            <View
              style={{
                width: '100%',
                flexDirection: 'column',
                paddingTop: 40,
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1, // FIXME(clairbee): does it help?
              }}
            >
              <Text
                style={{
                  fontFamily: styles.primaryFont700,
                  fontWeight: '700',
                  fontSize: 14,
                  lineHeight: 20,
                  color: styles.primaryColor,
                  margin: 10,
                  marginBottom: 0,
                  textTransform: 'uppercase',
                  alignSelf: 'flex-start',
                }}
              >
                {translate('main_featured_title')}
              </Text>
              {APPS[lang].map((uuid) => (
                <AppBadgeById
                  style={{
                    width: '100%',
                    maxWidth: 500,
                  }}
                  uuid={uuid}
                  history={history}
                />
              ))}
            </View>
          )}

          {/* The list of tags. */}
          {TAGS[lang] && (
            <View
              style={{
                width: '100%',
                flexDirection: 'row',
                paddingTop: 40,
                flexWrap: 'wrap',
              }}
            >
              {TAGS[lang].map((tag) => (
                <TouchableOpacity
                  accessibilityLabel={tag}
                  accessibilityRole="link"
                  href={`/ai-agents/${tag}`}
                  style={{
                    padding: 0,
                    margin: 10,
                  }}
                  key={tag}
                  onPress={() => {
                    history.push(`/ai-agents/${tag}`);
                  }}
                >
                  <Text
                    style={{
                      color: styles.primaryColor,
                      textDecorationLine: 'underline',
                    }}
                  >
                    {translate('main_link', { tag })}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          )}

          {/* The 'About' section */}
          <View
            style={{
              width: '100%',
              // flexDirection: 'row',
              marginTop: 50,
              paddingTop: 50,
              paddingBottom: 50,
              paddingHorizontal: 38,
              // flexWrap: 'wrap',
              justifyContent: 'flex-start',
              backgroundColor: styles.primaryColor,
            }}
          >
            <Text
              style={{
                fontFamily: styles.primaryFont700,
                fontWeight: '700',
                fontSize: 14,
                lineHeight: 20,
                color: 'white',
                textTransform: 'uppercase',
                margin: 10,
              }}
            >
              {translate('main_about_intro')}
            </Text>
            <Text
              style={{
                fontFamily: styles.primaryFont700,
                fontWeight: '700',
                fontSize: 32,
                lineHeight: 40,
                color: 'white',
                margin: 10,
              }}
            >
              {translate('main_about_title')}
            </Text>
            <Text
              style={{
                fontFamily: styles.primaryFont400,
                fontWeight: '400',
                fontSize: 14,
                lineHeight: 28,
                color: 'white',
                margin: 10,
              }}
            >
              {translate('main_about_text')}
            </Text>
            <View
              style={{
                width: '100%',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              <Button
                title={translate('main_more')}
                // containerStyle={{
                //   alignSelf: 'center',
                // }}
                containerStyle={styles.button.secondaryContainer}
                buttonStyle={[styles.button.secondary, {
                  // backgroundColor: '#ffffffC0',
                  backgroundColor: '#F2F2F2',
                }]}
                // disabledStyle={styles.button.secDisabled}
                titleStyle={styles.button.secondaryTitle}
                // disabledTitleStyle={styles.button.primaryTitleDisabled}
                onPress={() => {
                  history.push('/about');
                }}
              />
            </View>
            <ImageLogoUnderlay
              style={{
                position: 'absolute',
                width: 369,
                height: 388,
                right: 10,
                bottom: -65,
                zIndex: -10,
              }}
            />
          </View>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              paddingTop: 40,
              paddingBottom: 90,
              paddingHorizontal: 10,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <Text
              style={{
                fontFamily: styles.primaryFont500,
                fontWeight: '500',
                fontSize: 14,
                lineHeight: 17.5,
                color: 'black',
                opacity: 0.3,
                textTransform: 'uppercase',
                marginHorizontal: 10,
              }}
            >
              {translate('main_copyright')}
            </Text>
            <Text
              style={{
                fontFamily: styles.primaryFont500,
                fontWeight: '500',
                fontSize: 14,
                lineHeight: 17.5,
                color: 'black',
                opacity: 0.3,
                textTransform: 'uppercase',
                marginHorizontal: 10,
              }}
            >
              <a href="/privacy">{translate('privacy')}</a>
            </Text>
          </View>
        </ScrollFading>
      </View>
    );
  }
}

Main.defaultProps = {
  user: null,
};

Main.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  user: AORTypes.AWS.Cognito.User,
};

export default Main;
